import { ListItemText, Menu, MenuItem } from '../index';
import { pagesText } from '../../constants/pagesText';
import { Link as RouterLink } from 'react-router-dom';

const BulkActionsMenu = ({ anchorEl, onClose }) => (
  <Menu
    anchorEl={anchorEl}
    onClose={onClose}
    transformOrigin={{ horizontal: 'left', vertical: 'top' }}
    anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
    styles={{
      maxWidth: 175,
      boxShadow: 'unset',
    }}
    sx={{
      '& .MuiPaper-root': {
        marginTop: 0,
      },
    }}>
    <MenuItem
      component={RouterLink}
      to="/portal/bulk-download"
      styles={{
        padding: '12px',
        whiteSpace: 'normal',
      }}>
      <ListItemText
        primary={pagesText.bulkDownloadPage.bulkDownload}
        primaryStyles={{
          fontSize: 12,
          lineHeight: '30px',
          fontWeight: 400,
          color: '#fff',
        }}
      />
    </MenuItem>
  </Menu>
);

export default BulkActionsMenu;
